module.exports = __webpack_public_path__ + "static/image5-3cb0ff174705f8a4bbe5c6e6d89368b9.jpg";